// Shared "Sahod.solutions" wordmark with a de-emphasized ".solutions" TLD.
// The base size/weight/color come from the surrounding context (landing nav
// brand, auth branding panel, sidebar header) — only the ".solutions"
// de-emphasis (.wordmark-tld) is shared here. Render it inside the context's
// own element, e.g. <h1><Wordmark /></h1>. Replaces three near-identical local
// copies (brand__tld / auth-brand-tld / saas-tld). (BL-003)
//
// The outer <span> keeps "Sahod" and ".solutions" as ONE inline unit so a
// parent flex `gap` (e.g. the landing nav brand, the auth logo lockup) can't
// wedge space between them.
export function Wordmark() {
  return (
    <span className="wordmark">
      Sahod<span className="wordmark-tld">.solutions</span>
    </span>
  );
}
